/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_LoadingInputs */

const en_agent_authorization_loading = /** @type {(inputs: Agent_Authorization_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading authorization request...`)
};

const zh_agent_authorization_loading = /** @type {(inputs: Agent_Authorization_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载授权请求...`)
};

/**
* | output |
* | --- |
* | "Loading authorization request..." |
*
* @param {Agent_Authorization_LoadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_loading = /** @type {((inputs?: Agent_Authorization_LoadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_LoadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_loading(inputs)
	return zh_agent_authorization_loading(inputs)
});
export { agent_authorization_loading as "agent.authorization.loading" }